import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
// import { NavLink } from "react-router-dom";
import HomeBannerImg3 from "../../utils/images/home-banner-img3.png";
import sumoimg2 from "../../utils/images/sumo-img2.svg";
import takeawaysimg from "../../utils/images/takeaways-img.svg";
import handimg2 from "../../utils/images/hand-img2.svg";
import handimg from "../../utils/images/hand-img.svg";
import PopupImg from "../../utils/images/popup-img.svg";
import merchanticon1 from "../../utils/images/merchant-icon1.svg";
import merchanticon2 from "../../utils/images/merchant-icon2.svg";
import merchanticon3 from "../../utils/images/merchant-icon3.svg";
import merchanticon4 from "../../utils/images/merchant-icon4.svg";
import merchanticon5 from "../../utils/images/merchant-icon5.svg";
import merchanticon6 from "../../utils/images/merchant-icon6.svg";
import WhatsaapIcon1 from "../../utils/images/whatsaap-icon1.svg";
import MenuShareIcon1 from "../../utils/images/menu-share1.svg";
import numbericon1 from "../../utils/images/number-icon1.svg";
import numbericon2 from "../../utils/images/number-icon2.svg";
import numbericon3 from "../../utils/images/number-icon3.svg";
import numbericon4 from "../../utils/images/number-icon4.svg";
import numbericon5 from "../../utils/images/number-icon5.svg";
import numbericon6 from "../../utils/images/number-icon6.svg";
import numbericon7 from "../../utils/images/number-icon7.svg";
import numbericon8 from "../../utils/images/number-icon8.svg";
import telegram from "../../utils/images/telegram.svg";
import EmailIcon1 from "../../utils/images/email-icon1.svg";
import instagramIcon from "../../utils/images/instagram-icon.svg";
import facebookIcon from "../../utils/images/facebook-icon.svg";
import youtubeIcon from "../../utils/images/youtube.png";
import tiktokIcon from "../../utils/images/tiktok-black.svg";
import snapchatIcon from "../../utils/images/snapchat.png";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { commonFunctions } from "../../utils/commonFunctions";
import { useDispatch, useSelector } from "react-redux";
import { status } from "../../_constants";
import { alert } from "../../utils/commonFunctions/alert";
import { authActions } from "../../_action/auth.action";
import CustomLoader from "../../utils/commonFunctions/commonLoader";
import Maskbg from "../../utils/images/Mask-bg.svg";
import Subtractionbg from "../../utils/images/Subtraction-bg.svg";
import spreadicon from "../../utils/images/spread-icon.svg";
import ShareIcon1 from "../../utils/images/share-icon1.svg";
import { config } from "../../config/config";

function LandingInfluencers(props) {
  const influencerRegistrationData = useSelector((state) => state.landing);
  const totalInfluencerData = useSelector((state) => state.landing);
  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [shows, setShows] = useState(false);
  const [validate, setValidate] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    mobileNumber: "",
    instagramHandle: "",
    facebookHandle: "",
    youtubeHandle: "",
    tiktokHandle: "",
    snapchatHandle: "",
    totalFollowers: "",
    primaryPlatform: "",
    contentFocus: [],
  });
  const [errors, setError] = useState({
    fullName: { message: "", validate: true },
    email: { message: "", validate: true },
    mobileNumber: { message: "", validate: true },
    instagramHandle: { message: "", validate: true },
    facebookHandle: { message: "", validate: true },
    youtubeHandle: { message: "", validate: true },
    tiktokHandle: { message: "", validate: true },
    snapchatHandle: { message: "", validate: true },
    totalFollowers: { message: "", validate: true },
    primaryPlatform: { message: "", validate: true },
    contentFocus: { message: "", validate: true },
  });

  const navigate = useNavigate();
  const [waitlist, setWaitlist] = useState(0);
  const handleModal = () => {
    setShow(!show);
  };
  const handleModals = () => {
    setShows(!shows);
  };
  var setting = {
    dots: false,
    infinite: false,
    speed: 800,
    slidesToShow: 3.8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
    ],
  };

  useEffect(() => {
    dispatch(authActions.totalInfluencer());
  }, []);

  useEffect(() => {
    console.log("totalInfluencerData", totalInfluencerData);
    if (
      totalInfluencerData &&
      totalInfluencerData.get_influencer_total_status == status.SUCCESS
    ) {
      console.log(
        "totalInfluencerData",
        totalInfluencerData.get_influencer_total_data
      );
      setWaitlist(totalInfluencerData.get_influencer_total_data.total);
    }
  }, [totalInfluencerData.get_influencer_total_data]);

  useEffect(() => {
    validation(validate);
  }, [formData]);

  useEffect(() => {
    if (
      influencerRegistrationData &&
      influencerRegistrationData.get_influencer_status == status.SUCCESS
    ) {
      localStorage.setItem(
        "i_ID",
        influencerRegistrationData.get_influencer_data?.user?.id
      );
      setShowLoader(false);
      alert.success("You’re on the waitlist!");
      clearFormData();
      setShow(false);
      navigate("/influencers/thankyou", { scroll: "top" });
    } else {
      setShowLoader(false);
      if (
        influencerRegistrationData.get_influencer_data != null &&
        influencerRegistrationData.get_influencer_data.status == 409
      ) {
        setShowLoader(false);
        return alert.error(
          influencerRegistrationData.get_influencer_data.error
        );
      } else if (influencerRegistrationData.get_influencer_data != null) {
        setShowLoader(false);
        return alert.error("Something went wrong");
      }
    }
  }, [influencerRegistrationData.get_influencer_data]);

  const clearFormData = () => {
    setFormData({
      fullName: "",
      email: "",
      mobileNumber: "",
      instagramHandle: "",
      facebookHandle: "",
      youtubeHandle: "",
      tiktokHandle: "",
      snapchatHandle: "",
      totalFollowers: "",
      primaryPlatform: "",
      contentFocus: [],
    });
    setValidate(false);
    setError({
      fullName: { message: "", validate: true },
      email: { message: "", validate: true },
      mobileNumber: { message: "", validate: true },
      instagramHandle: { message: "", validate: true },
      facebookHandle: { message: "", validate: true },
      youtubeHandle: { message: "", validate: true },
      tiktokHandle: { message: "", validate: true },
      snapchatHandle: { message: "", validate: true },
      totalFollowers: { message: "", validate: true },
      primaryPlatform: { message: "", validate: true },
      contentFocus: { message: "", validate: true },
    });
  };

  const validation = (validate = false) => {
    if (validate === true) {
      if (formData.fullName === "") {
        errors.fullName.message = "Full name is required";
        errors.fullName.validate = false;
      } else {
        errors.fullName.message = "";
        errors.fullName.validate = true;
      }

      if (formData.email === "") {
        errors.email.message = "Email is required";
        errors.email.validate = false;
      } else if (
        formData.email &&
        !commonFunctions.validateEmail(formData.email)
      ) {
        errors.email.message = "Email is not valid";
        errors.email.validate = false;
      } else {
        errors.email.message = "";
        errors.email.validate = true;
      }

      if (formData.mobileNumber === "") {
        errors.mobileNumber.message = "Phone number is required";
        errors.mobileNumber.validate = false;
      } else if (
        formData.mobileNumber &&
        !commonFunctions.validateConatctNumber(formData.mobileNumber)
      ) {
        errors.mobileNumber.message =
          "Please enter valid phone number of 11 digits";
        errors.mobileNumber.validate = false;
      } else {
        errors.mobileNumber.message = "";
        errors.mobileNumber.validate = true;
      }

      // Social handles validation (at least one required)
      const hasSocialHandle =
        formData.instagramHandle ||
        formData.facebookHandle ||
        formData.youtubeHandle ||
        formData.tiktokHandle ||
        formData.snapchatHandle;

      if (!hasSocialHandle) {
        errors.instagramHandle.message =
          "At least one social handle is required";
        errors.instagramHandle.validate = false;
      } else {
        errors.instagramHandle.message = "";
        errors.instagramHandle.validate = true;
      }

      errors.facebookHandle.message = "";
      errors.facebookHandle.validate = true;
      errors.youtubeHandle.message = "";
      errors.youtubeHandle.validate = true;
      errors.tiktokHandle.message = "";
      errors.tiktokHandle.validate = true;
      errors.snapchatHandle.message = "";
      errors.snapchatHandle.validate = true;

      if (formData.totalFollowers === "") {
        errors.totalFollowers.message = "This field is required";
        errors.totalFollowers.validate = false;
      } else {
        errors.totalFollowers.message = "";
        errors.totalFollowers.validate = true;
      }

      if (formData.primaryPlatform === "") {
        errors.primaryPlatform.message = "Primary platform is required";
        errors.primaryPlatform.validate = false;
      } else {
        errors.primaryPlatform.message = "";
        errors.primaryPlatform.validate = true;
      }

      if (formData.contentFocus.length === 0) {
        errors.contentFocus.message = "At least one content focus is required";
        errors.contentFocus.validate = false;
      } else {
        errors.contentFocus.message = "";
        errors.contentFocus.validate = true;
      }

      setError({ ...errors });
    }
    return errors;
  };

  const submitUserDetail = () => {
    setValidate(true);
    let validateData = validation(true);
    let validate = true;
    for (let key in validateData) {
      if (validateData[key].validate === false) {
        validate = false;
        return null;
      }
    }
    if (validate === true) {
      const data = {
        name: formData.fullName,
        email: formData.email,
        phone: formData.mobileNumber,
        instagram: formData.instagramHandle,
        facebook: formData.facebookHandle,
        youtube: formData.youtubeHandle,
        tiktok: formData.tiktokHandle,
        snapchat: formData.snapchatHandle,
        totalFollowers: formData.totalFollowers,
        primaryPlatform: formData.primaryPlatform,
        contentFocus: formData.contentFocus,
      };
      setValidate(false);
      dispatch(authActions.influencerRegister(data));
      setShowLoader(true);
    }
  };

  const handleContentFocusToggle = (focus) => {
    const currentFocus = [...formData.contentFocus];
    const index = currentFocus.indexOf(focus);
    if (index > -1) {
      currentFocus.splice(index, 1);
    } else {
      currentFocus.push(focus);
    }
    setFormData({ ...formData, contentFocus: currentFocus });
  };

  const handleInputChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  return (
    <aap-home>
      {showLoader ? (
        <CustomLoader />
      ) : (
        <div className="main-wrapper" id="home-page">
          <div className="shadow2">
            <img src={HomeBannerImg3} alt="" className="home-img2" />
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="home-banner takeaway">
                  <div className="home-banner-img">
                    <img src={sumoimg2} alt="" />
                  </div>
                  <div className="my-sumo-button">
                    <h2>
                      Attention Influencers! Don't Miss Out on the SumoEats
                      Revolution!
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="home-link-list takeaway">
            <div className="container">
              <div className="row">
                <div className="takeaway-block">
                  <div className="home-banner-img">
                    <img src={takeawaysimg} alt="" />
                  </div>
                  <div className="benefits-box">
                    <p>
                      You’re officially on our SumoEats Influencer list. Sign up to complete onboarding, lock in your spot for the soft launch, and get first access to takeaway partnerships, creator-only deals, and perks.
                    </p>
                    <h3>
                      {console.log("waitlist", waitlist)}
                      You’re going to be <strong>#{50 + waitlist}</strong> on
                      the SumoEats Influencer list.
                    </h3>
                    <div className="get-in-btn">
                      <button
                        title="Sign Up Now"
                        className="primary-btn sm sign-btn"
                        onClick={() => handleModal()}
                      >
                        <span>
                          <img src={handimg} alt="" />
                        </span>
                        Sign Up Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="merchants-section">
            <div className="container">
              <div className="text-content text-center">
                <h2>8 Benefits of Joining SumoEats for Influencers</h2>
              </div>
              <div className="row text-center d-none d-md-flex">
                <div className="col-sm-3">
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <h3>1</h3>
                    </div>
                    <div className="benefits-content">
                      <h5>Monetize Content</h5>
                      <p>
                        Turn your food posts into a steady income stream with
                        competitive referral commissions.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <h3>2</h3>
                    </div>
                    <div className="benefits-content">
                      <h5>Exclusive Deals</h5>
                      <p>
                        Unlock special discounts and limited-time offers
                        available only to our partner influencers.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <h3>3</h3>
                    </div>
                    <div className="benefits-content">
                      <h5>Exclusive Events</h5>
                      <p>
                        Get VIP access to restaurant openings, tasting menus,
                        and creator networking parties.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <h3>4</h3>
                    </div>
                    <div className="benefits-content">
                      <h5>Grow Your Audience</h5>
                      <p>
                        Get featured on the SumoEats app and social channels to
                        reach thousands of new hungry followers.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <h3>5</h3>
                    </div>
                    <div className="benefits-content">
                      <h5>Effective Tracking</h5>
                      <p>
                        Use our creator dashboard to track every click, order,
                        and commission in real-time.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <h3>6</h3>
                    </div>
                    <div className="benefits-content">
                      <h5>Flexible Schedule</h5>
                      <p>
                        Work on your own terms. Promote when you eat, earn when
                        they order. No strict deadlines.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <h3>7</h3>
                    </div>
                    <div className="benefits-content">
                      <h5>Brand Networking</h5>
                      <p>
                        Connect directly with local restaurant owners looking
                        for long-term brand ambassadors.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <h3>8</h3>
                    </div>
                    <div className="benefits-content">
                      <h5>Fast Payouts</h5>
                      <p>
                        Don't wait months for your money. We process creator
                        payments weekly directly to your bank.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mobile-slider d-flex d-md-none">
                <div>
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <img src={numbericon1} alt="" />
                    </div>
                    <div className="benefits-content">
                      <h5>Monetize Content</h5>
                      <p>
                        Turn your food posts into a steady income stream with
                        competitive referral commissions.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <img src={numbericon2} alt="" />
                    </div>
                    <div className="benefits-content">
                      <h5>Exclusive Deals</h5>
                      <p>
                        Unlock special discounts and limited-time offers
                        available only to our partner influencers.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <img src={numbericon3} alt="" />
                    </div>
                    <div className="benefits-content">
                      <h5>Exclusive Events</h5>
                      <p>
                        Get VIP access to restaurant openings, tasting menus,
                        and creator networking parties.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <img src={numbericon4} alt="" />
                    </div>
                    <div className="benefits-content">
                      <h5>Grow Your Audience</h5>
                      <p>
                        Get featured on the SumoEats app and social channels to
                        reach thousands of new hungry followers.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <img src={numbericon5} alt="" />
                    </div>
                    <div className="benefits-content">
                      <h5>Effective Tracking</h5>
                      <p>
                        Use our creator dashboard to track every click, order,
                        and commission in real-time.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <img src={numbericon6} alt="" />
                    </div>
                    <div className="benefits-content">
                      <h5>Flexible Schedule</h5>
                      <p>
                        Work on your own terms. Promote when you eat, earn when
                        they order. No strict deadlines.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <img src={numbericon7} alt="" />
                    </div>
                    <div className="benefits-content">
                      <h5>Brand Networking</h5>
                      <p>
                        Connect directly with local restaurant owners looking
                        for long-term brand ambassadors.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="benefits-detail">
                    <div className="benifit-number">
                      <img src={numbericon8} alt="" />
                    </div>
                    <div className="benefits-content">
                      <h5>Fast Payouts</h5>
                      <p>
                        Don't wait months for your money. We process creator
                        payments bi-weekly directly to your bank.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="get-in-btn text-center">
                <button
                  title="Sign Up Now"
                  className="primary-btn sm sign-btn"
                  onClick={() => handleModal()}
                >
                  <span>
                    <img src={handimg2} alt="" />
                  </span>
                  Sign Up Now
                </button>
              </div>
            </div>
          </div>
          <div className="merchants-section-slider d-none d-md-block">
            <div className="container">
              <div className="mobile-slider">
                <h2 className="text-center">
                 Why SumoEats is the Ideal Choice for Influencers
                </h2>
                <Slider {...setting}>
                  <div>
                    <div className="benefits-detail">
                      <div className="benifit-number">
                        <img src={merchanticon1} alt="" />
                      </div>
                      <div className="benefits-content">
                        <h5>Community First</h5>
                        <p>
                          Join a supportive community of like-minded foodies and
                          creators sharing tips and growth strategies.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="benefits-detail">
                      <div className="benifit-number">
                        <img src={merchanticon2} alt="" />
                      </div>
                      <div className="benefits-content">
                        <h5>Easy Platform</h5>
                        <p>
                          Our intuitive app makes it simple to generate links,
                          track earnings, and withdraw funds.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="benefits-detail">
                      <div className="benifit-number">
                        <img src={merchanticon3} alt="" />
                      </div>
                      <div className="benefits-content">
                        <h5>High Growth</h5>
                        <p>
                          Benefit from SumoEats' massive marketing campaigns
                          designed to drive traffic and awareness.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="benefits-detail">
                      <div className="benifit-number">
                        <img src={merchanticon4} alt="" />
                      </div>
                      <div className="benefits-content">
                        <h5>Custom Deals</h5>
                        <p>
                          Create unique promo codes for your audience to ensure
                          maximum conversion and ROI.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="benefits-detail">
                      <div className="benifit-number">
                        <img src={merchanticon5} alt="" />
                      </div>
                      <div className="benefits-content">
                        <h5>Analytics & Insights</h5>
                        <p>
                          Get detailed performance reports to understand which
                          content drives the most orders.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="benefits-detail">
                      <div className="benifit-number">
                        <img src={merchanticon6} alt="" />
                      </div>
                      <div className="benefits-content">
                        <h5>Dedicated Support</h5>
                        <p>
                          Access our VIP support team for campaign help,
                          technical issues, or partnership questions.
                        </p>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
              <div className="get-in-btn text-center">
                <button
                  title="Sign Up Now"
                  className="primary-btn sm sign-btn"
                  onClick={() => handleModal()}
                >
                  <span>
                    <img src={handimg} alt="" />
                  </span>
                  Sign Up Now
                </button>
              </div>
            </div>
          </div>
          <div className="merchants-section-slider d-flex d-md-none">
            <div className="container">
              <div className="mobile-slider">
                <h2 className="text-center">
                  Why SumoEats is the Ideal Choice for Merchants
                </h2>
                <div className="scroll-slider d-flex d-md-none">
                  <div>
                    <div className="benefits-detail">
                      <div className="benifit-number">
                        <img src={merchanticon1} alt="" />
                      </div>
                      <div className="benefits-content">
                        <h5>Community First</h5>
                        <p>
                          Join a supportive community of like-minded foodies and
                          creators sharing tips and growth strategies.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="benefits-detail">
                      <div className="benifit-number">
                        <img src={merchanticon2} alt="" />
                      </div>
                      <div className="benefits-content">
                        <h5>Easy Platform</h5>
                        <p>
                          Our intuitive app makes it simple to generate links,
                          track earnings, and withdraw funds.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="benefits-detail">
                      <div className="benifit-number">
                        <img src={merchanticon3} alt="" />
                      </div>
                      <div className="benefits-content">
                        <h5>High Growth</h5>
                        <p>
                          Benefit from SumoEats' massive marketing campaigns
                          designed to drive traffic and awareness.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="benefits-detail">
                      <div className="benifit-number">
                        <img src={merchanticon4} alt="" />
                      </div>
                      <div className="benefits-content">
                        <h5>Custom Deals</h5>
                        <p>
                          Create unique promo codes for your audience to ensure
                          maximum conversion and ROI.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="benefits-detail">
                      <div className="benifit-number">
                        <img src={merchanticon5} alt="" />
                      </div>
                      <div className="benefits-content">
                        <h5>Analytics & Insights</h5>
                        <p>
                          Get detailed performance reports to understand which
                          content drives the most orders.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="benefits-detail">
                      <div className="benifit-number">
                        <img src={merchanticon6} alt="" />
                      </div>
                      <div className="benefits-content">
                        <h5>Dedicated Support</h5>
                        <p>
                          Access our VIP support team for campaign help,
                          technical issues, or partnership questions.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="get-in-btn text-center">
                <button
                  title="Sign Up Now"
                  className="primary-btn sm sign-btn"
                  onClick={() => handleModal()}
                >
                  <span>
                    <img src={handimg} alt="" />
                  </span>
                  Sign Up Now
                </button>
              </div>
            </div>
          </div>
          <div className="benefits-box merchants-box">
            <img src={Maskbg} alt="" className="benefits-background" />
            <img src={Subtractionbg} alt="" className="benefits-bg" />
            <div className="benefits-text">
              <div className="container">
                <img src={spreadicon} alt="" />
                <h2>Spread the luuurve!</h2>
                <p>Invite fellow food creators.</p>
                <div className="get-in-btn">
                  <button
                    title="Share Now"
                    className="primary-btn sm share-btn"
                    onClick={() => handleModals()}
                  >
                    <span>
                      <img src={ShareIcon1} alt="" />
                    </span>
                    Share Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal
        show={show}
        onHide={() => {
          handleModal();
          setError({
            fullName: { message: "", validate: true },
            email: { message: "", validate: true },
            mobileNumber: { message: "", validate: true },
            instagramHandle: { message: "", validate: true },
            facebookHandle: { message: "", validate: true },
            youtubeHandle: { message: "", validate: true },
            tiktokHandle: { message: "", validate: true },
            snapchatHandle: { message: "", validate: true },
            totalFollowers: { message: "", validate: true },
            primaryPlatform: { message: "", validate: true },
            contentFocus: { message: "", validate: true },
          });
          setValidate(false);
        }}
        size="lg"
        className="signup-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="signup-modal-inner">
            <div>
              <form>
                <img src={PopupImg} alt="" />
                <h2>Ready for SumoEats!</h2>
                <div className="form-group form-group-blue">
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={(e) => {
                      handleInputChange("fullName", e.target.value);
                    }}
                    placeholder="Name"
                  />
                  {errors?.fullName?.message !== "" && (
                    <p>{errors?.fullName?.message}</p>
                  )}
                </div>
                <div className="form-group form-group-blue">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => {
                      handleInputChange("email", e.target.value);
                    }}
                    placeholder="john@example.com"
                  />
                  {errors?.email?.message !== "" && (
                    <p>{errors?.email?.message}</p>
                  )}
                </div>
                <div className="form-group form-group-blue">
                  <input
                    type="text"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    maxLength="11"
                    minLength="11"
                    inputMode="numeric"
                    onChange={(e) => {
                      handleInputChange("mobileNumber", e.target.value);
                    }}
                    placeholder="07700 900000"
                  />
                  {errors?.mobileNumber?.message !== "" && (
                    <p>{errors?.mobileNumber?.message}</p>
                  )}
                </div>
                <div className="form-group form-group-blue social-handles-group">
                  <label style={{ placeSelf: "center" }}>Social Handles</label>
                  <div className="input-with-icon">
                    <img
                      src={instagramIcon}
                      alt="Instagram"
                      className="input-icon"
                    />
                    <input
                      type="text"
                      name="instagramHandle"
                      value={formData.instagramHandle}
                      onChange={(e) => {
                        handleInputChange("instagramHandle", e.target.value);
                      }}
                      placeholder="instagram.com/username"
                    />
                  </div>
                  <div className="input-with-icon">
                    <img
                      src={facebookIcon}
                      alt="Facebook"
                      className="input-icon"
                    />
                    <input
                      type="text"
                      name="facebookHandle"
                      value={formData.facebookHandle}
                      onChange={(e) => {
                        handleInputChange("facebookHandle", e.target.value);
                      }}
                      placeholder="facebook.com/username"
                    />
                  </div>
                  <div className="input-with-icon">
                    <img
                      src={youtubeIcon}
                      alt="YouTube"
                      className="input-icon"
                    />
                    <input
                      type="text"
                      name="youtubeHandle"
                      value={formData.youtubeHandle}
                      onChange={(e) => {
                        handleInputChange("youtubeHandle", e.target.value);
                      }}
                      placeholder="youtube.com/channel"
                    />
                  </div>
                  <div className="input-with-icon">
                    <img src={tiktokIcon} alt="TikTok" className="input-icon" />
                    <input
                      type="text"
                      name="tiktokHandle"
                      value={formData.tiktokHandle}
                      onChange={(e) => {
                        handleInputChange("tiktokHandle", e.target.value);
                      }}
                      placeholder="tiktok.com/@username"
                    />
                  </div>
                  <div className="input-with-icon">
                    <img
                      src={snapchatIcon}
                      alt="Snapchat"
                      className="input-icon"
                    />
                    <input
                      type="text"
                      name="snapchatHandle"
                      value={formData.snapchatHandle}
                      onChange={(e) => {
                        handleInputChange("snapchatHandle", e.target.value);
                      }}
                      placeholder="snapchat.com/add/username"
                    />
                  </div>
                  {errors?.instagramHandle?.message !== "" && (
                    <p>{errors?.instagramHandle?.message}</p>
                  )}
                </div>
                <div className="form-group form-group-blue">
                  <input
                    type="text"
                    name="totalFollowers"
                    value={formData.totalFollowers}
                    onChange={(e) => {
                      handleInputChange("totalFollowers", e.target.value);
                    }}
                    placeholder="Total followers (e.g. 50k, 1m)"
                  />
                  {errors?.totalFollowers?.message !== "" && (
                    <p>{errors?.totalFollowers?.message}</p>
                  )}
                </div>
                <div className="form-group form-group-blue">
                  <input
                    type="text"
                    name="primaryPlatform"
                    value={formData.primaryPlatform}
                    onChange={(e) => {
                      handleInputChange("primaryPlatform", e.target.value);
                    }}
                    placeholder="Primary content platform (e.g. Instagram Reels)"
                  />
                  {errors?.primaryPlatform?.message !== "" && (
                    <p>{errors?.primaryPlatform?.message}</p>
                  )}
                </div>
                <div className="form-group form-group-blue">
                  <label style={{ placeSelf: "center" }}>Content Focus</label>
                  <div className="content-focus-buttons">
                    <button
                      type="button"
                      className={`focus-btn ${
                        formData.contentFocus.includes("Food") ? "active" : ""
                      }`}
                      onClick={() => handleContentFocusToggle("Food")}
                    >
                      Food
                    </button>
                    <button
                      type="button"
                      className={`focus-btn ${
                        formData.contentFocus.includes("Lifestyle")
                          ? "active"
                          : ""
                      }`}
                      onClick={() => handleContentFocusToggle("Lifestyle")}
                    >
                      Lifestyle
                    </button>
                    <button
                      type="button"
                      className={`focus-btn ${
                        formData.contentFocus.includes("Fashion")
                          ? "active"
                          : ""
                      }`}
                      onClick={() => handleContentFocusToggle("Fashion")}
                    >
                      Fashion
                    </button>
                    <button
                      type="button"
                      className={`focus-btn ${
                        formData.contentFocus.includes("Travel") ? "active" : ""
                      }`}
                      onClick={() => handleContentFocusToggle("Travel")}
                    >
                      Travel
                    </button>
                    <button
                      type="button"
                      className={`focus-btn ${
                        formData.contentFocus.includes("Fun") ? "active" : ""
                      }`}
                      onClick={() => handleContentFocusToggle("Fun")}
                    >
                      Fun
                    </button>
                  </div>
                  {errors?.contentFocus?.message !== "" && (
                    <p>{errors?.contentFocus?.message}</p>
                  )}
                </div>
              </form>
              <button
                title="Secure My Spot"
                className="primary-btn sm sign-btn"
                onClick={() => {
                  submitUserDetail();
                }}
              >
                <span>
                  <img src={handimg} alt="" />
                </span>
                Secure My Spot
              </button>
              <p>
                Rest assured, your information is safe with us. We never share
                your data with anyone outside SumoEats.
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={shows}
        onHide={() => handleModals()}
        size="lg"
        className="share-popup-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="share-popup-modal-inner">
            <div className="share-popup">
              <img src={PopupImg} alt="" />
              <h2>Spread the luuurve!</h2>
              <p>Share with friends and family</p>
              <ul>
                <li>
                  <a
                    href="https://wa.me/?text=https://sumoeats.co.uk/influencers/"
                    target="_blank"
                  >
                    <img src={WhatsaapIcon1} alt="" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://t.me/share/url?url=https://sumoeats.co.uk/influencers/"
                    target="_blank"
                  >
                    <img src={telegram} alt="" />
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:hello@sumoeats.co.uk&amp;subject=Sumoeats&amp;body=I wanna be Sumohttps://sumoeats.co.uk/influencers/"
                    target="_blank"
                  >
                    <img src={EmailIcon1} alt="" />
                  </a>
                </li>
                <li>
                  <img
                    src={MenuShareIcon1}
                    alt=""
                    onClick={() =>
                      navigator.clipboard.writeText(
                        "https://sumoeats.co.uk/influencers/"
                      )
                    }
                  />
                </li>
              </ul>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </aap-home>
  );
}

export default LandingInfluencers;
